module.exports = __webpack_public_path__ + "static/media/mdb_logo.3d2ea394.svg";